import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";

export default class FieldChange extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.PassSacked;
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        let newPosition = fragment.sackedAt;
        gameContext.setFieldPosition(newPosition);
    }
}
